<template>
  <InteractionStep waiting>
    <template v-slot:content>
      <div class="step-text">
        <h3 class="step-text__title">{{ $tInteraction('Custom step title') }}</h3>
        <div class="step-text__text text">
          <p>{{ $tInteraction('Custom step text') }}</p>
        </div>

      </div>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '../InteractionStep'

  export default {
    components: {
      InteractionStep
    },
    computed: {}
  }
</script>

<style lang="less">

</style>
